// extracted by mini-css-extract-plugin
module.exports = {"genreBox":"Genre_genreBox__F2kY-","genre":"Genre_genre__1R38A"};